import React from 'react' 
import { css, keyframes } from '@emotion/react'
import { Theme2 } from './Layout'
import { fadeIn } from 'react-animations'

const Modal = (props) =>{
    const animation = keyframes`${fadeIn}`;

   return(
       <>
{props.modalOpen === true &&
<div css={css`
position: fixed;
top: 0;
bottom: 0;
left: 0;
right: 0;
background-color: ${Theme2.colors.modalBackgroundColor};
display: flex;
align-items: center;
justify-content: center;
z-index: 6;
animation: 0.5s ${animation};
`}
>
    <button css={css`
    appearance: none;
    padding: 0.5em;
    border: 1px solid ${Theme2.colors.light};
    position: absolute;
    top: 20px;
    right: 20px;
    transition: all 0.25s;
    z-index: 1;

    &:hover{
        background-color: ${Theme2.colors.light};
        color: ${Theme2.colors.text};
    }
    `}
    onClick={props.onClose}
    >
        x
    </button>
    <div css={css`
    width: 80%;
    max-width: 1469px;
    margin: 0 auto;
    `}>
    {props.modalContent}
    </div>
    
    

</div>
}
</>    
   )
}
export {Modal}